
import { PROFILES, getUserProfile } from './UserProfile';

import CoordenadorPage from '../components/coordenador/CoordenadorPage';
import AdminPage from '../components/admin/AdminPage';
import AlunoPage from '../components/aluno/AlunoPage';
import ProfessorPage from '../components/professor/ProfessorPage'

export default (userContainer) => {
    const userProfile = getUserProfile(userContainer.state.profile && userContainer.state.profile.decodedToken && userContainer.state.profile.decodedToken.role)
    switch (userProfile) {
        case PROFILES.ADMIN:
            return AdminPage
        case PROFILES.COORDENADOR:
        case PROFILES.GESTOR:
            return CoordenadorPage
        case PROFILES.PROFESSOR:
            return ProfessorPage
        default:
           return AlunoPage
    }
}
